export default "__VITE_ASSET__DZuaqu2p__"